// 暫停販售品項的彙整與時間顯示（首頁、出餐狀況空畫面、選單徽章共用）

// 彙整目前非正常販售的品項（套餐+單品，同名取最差狀態），2=暫停 3=停售
export const collectPausedProducts = (systemData) => {
    const byName = new Map();
    [...(systemData?.meal ?? []), ...(systemData?.food ?? [])].forEach((item) => {
        const status = Number(item.status);
        if (status < 2) return;
        const existing = byName.get(item.name);
        if (!existing || status > existing.status) {
            byName.set(item.name, { name: item.name, status });
        }
    });
    return Array.from(byName.values()).sort((a, b) => a.status - b.status);
};

const parseDateTime = (value) => {
    if (!value) return null;
    const date = new Date(String(value).replace(" ", "T"));
    return Number.isNaN(date.getTime()) ? null : date;
};

const pad = (value) => String(value).padStart(2, "0");

// 「已暫停 1小時5分 · 14:05起」；跨日改顯示日期；沒有紀錄回傳空字串
export const formatPausedSince = (since, nowMs = Date.now()) => {
    const date = parseDateTime(since);
    if (!date) return "";
    const minutes = Math.max(0, Math.floor((nowMs - date.getTime()) / 60000));
    let duration;
    if (minutes < 1) duration = "剛剛";
    else if (minutes < 60) duration = `${minutes}分`;
    else if (minutes < 24 * 60) {
        const rest = minutes % 60;
        duration = `${Math.floor(minutes / 60)}小時${rest ? `${rest}分` : ""}`;
    } else duration = `${Math.floor(minutes / (24 * 60))}天`;

    const now = new Date(nowMs);
    const sameDay = now.toDateString() === date.toDateString();
    const clock = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    const start = sameDay ? clock : `${date.getMonth() + 1}/${date.getDate()} ${clock}`;
    return `${duration === "剛剛" ? "剛剛暫停" : `已暫停 ${duration}`} · ${start}起`;
};

export const formatBadgeCount = (count) => (count > 99 ? "99+" : String(count));
